import React, { useEffect, useState } from "react";
import { Upload, Flex, Radio, notification, InputNumber, Select } from "antd";
import {
  InboxOutlined,
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import "react-quill/dist/quill.snow.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { create } from "../../controllers/interests/requestsController";
import { fetchIpAddress } from "../../controllers/API";
import { list as firmList } from "../../controllers/investors/investorController";
import { list as getinvestorUserList } from "../../controllers/investorsUsers/investorUsersController";
import { list as getCompanyList } from "../../controllers/company/companyController";


const EventsEditPage = () => {

  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditSata] = useState(state ? state : []);


  const [firmsList, setFirmList] = useState([]);
  const [investorUserList, setInvestorUserList] = useState([]);
  const [companyList, setCompanyList] = useState([]);

  const getFirmsList = async () => {
    try {
      setFirmList([]);
      const options = {
        type: "",
        condition: { status: "A" },
        select: {},
        sort: { investor_firm_name: 1 },
        skip: 0,
        limit: 0,
      };
      const listData = await firmList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setFirmList(listData?.result);
        } else {
          setFirmList([]);
        }
      } else {
        setFirmList([]);
      }
    } catch (error) {
      console.log("error", error);
      setFirmList([]);
    }
  }; //End

  const getCompaniesList = async () => {
    try {
      setCompanyList([]);
      const options = {
        type: "",
        condition: { status: "A" },
        select: {},
        sort: { company_name: 1 },
        skip: 0,
        limit: 0,
      };
      const listData = await getCompanyList(options);
      if (listData.status === true) {
        if (listData.result.length > 0) {
          setCompanyList(listData?.result);
        } else {
          setCompanyList([]);
        }
      } else {
        setCompanyList([]);
      }
    } catch (error) {
      console.log("error", error);
      setCompanyList([]);
    }
  }; //End
  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "investor_firm_id" || name === "investor_id" || name === "company_id") {
      setAddEditSata((pre) => ({
        ...pre,
        [name]: value ? JSON.parse(value) : "",
      }));
    } else {
      setAddEditSata((pre) => ({
        ...pre,
        [name]: value,
      }));
    }

    setError((pre) => ({
      ...pre,
      [name]: "",
    }));
  };


  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const {
        investor_firm_id,
        investor_id,
        company_id,
        admin_status,
        priority
      } = ADDEDITDATA;
      const ipAddress = await fetchIpAddress();

      const form = new FormData();

      form.append("investor_firm_id", investor_firm_id ? investor_firm_id?._id : "");
      form.append("investor_id", investor_id ? investor_id?._id : "");
      form.append("company_id", company_id ? company_id?._id : "");
      form.append("admin_status", admin_status);
      form.append("priority", priority);

      const isValidate = validateFormData(form);

      if (isValidate) {
        const params = {
          investor_firm_id: investor_firm_id._id,
          investor_id: investor_id._id,
          company_id: company_id._id,
          admin_status: admin_status,
          priority: priority
        }

        const options = {
          url: "requests/create",
          postData: params,
        };

        console.log(options);
        const res = await create(options);
        if (res.status === true) {
          notification.open({
            message: "Interest created!",
            description: `Data created successfully.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/requests-sent/list");
        } else {
          notification.open({
            message: "Opps!",
            description: `${res?.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        notification.open({
          message: "Opps!",
          description: `Please enter the required fields.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {

    if (
      !formData.get("investor_firm_id")?.trim() ||
      formData.get("investor_firm_id") === "" ||
      formData.get("investor_firm_id") === "undefined"
    ) {
      setError((prevError) => ({
        ...prevError,
        investor_firm_id: "Please select investor firm",
      }));
      return false;
    }

    if (
      !formData.get("investor_id")?.trim() ||
      formData.get("investor_id") === "" ||
      formData.get("investor_id") === "undefined"
    ) {
      setError((prevError) => ({
        ...prevError,
        investor_id: "Please select investor",
      }));
      return false;
    }

    if (
      !formData.get("company_id")?.trim() ||
      formData.get("company_id") === "" ||
      formData.get("company_id") === "undefined"
    ) {
      setError((prevError) => ({
        ...prevError,
        company_id: "Please select company",
      }));
      return false;
    }

    if (!formData.get("priority")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        priority: "Priority is required",
      }));
      return false;
    }

    if (!formData.get("admin_status")?.trim()) {
      setError((prevError) => ({
        ...prevError,
        admin_status: "Approve status is required",
      }));
      return false;
    }
    return true;
  };

  useEffect(() => {
    getFirmsList();
    getCompaniesList();
    document.title = "Chiratae Super Admin || Create Interests";
  }, []);

  
  useEffect(() => {
  const fetchInvestorUsers = async () => {
    try {
      setInvestorUserList([]);
      const options = {
        type: "",
        condition: { firm: ADDEDITDATA?.investor_firm_id?._id, status: "A" },
        select: {},
        sort: { investor_first_name: 1 },
        skip: 0,
        limit: 0,
      };
      const listData = await getinvestorUserList(options);

      if (listData.status === true && listData.result?.length > 0) {
        setInvestorUserList(listData.result);
      } else {
        setInvestorUserList([]);
      }
    } catch (error) {
      console.error("error", error);
      setInvestorUserList([]);
    }
  };

  if (ADDEDITDATA?.investor_firm_id?._id) {
    fetchInvestorUsers();
  }
}, [ADDEDITDATA?.investor_firm_id]);


  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <div>
            <h5 className="inventory_edit_page_heading">
              Create Interests
            </h5>
          </div>
          <Link to="/requests-sent/list">
            <div>
              <button type="button" className="btn btn-secondary">
                <ArrowLeftOutlined /> Back
              </button>
            </div>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form method="post" className="inventory_form_main_contnet">
                <div className="row inventory_form_main_content_form_section">
                  {/* { ADDEDITDATA.isReschedule === 'Y' ? ( */}
                    <div className="row">
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="investor_firm_id"
                          className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                        >
                        <span style={{ color: "red" }}>*</span>Select Firm :
                        </label>
                        <select
                          className="form-control"
                          name="investor_firm_id"
                          id="investor_firm_id"
                          onChange={handleChange}
                        >
                          <option value="">Select Investor Firm</option>
                          {firmsList.map((firms, index) => (
                            <option
                              value={JSON.stringify(firms)}
                              selected={firms?._id === ADDEDITDATA?.investor_firm_id?._id}
                              key={index}
                            >
                              {firms.investor_firm_name}
                            </option>
                          ))}
                        </select>
                        {error.investor_firm_id ? (
                          <p style={{ color: "red" }}>{error.investor_firm_id}</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="investor_id"
                          className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                        >
                        <span style={{ color: "red" }}>*</span>Select Investor :
                        </label>
                        <select
                          className="form-control"
                          name="investor_id"
                          id="investor_id"
                          onChange={handleChange}
                        >
                          <option value="">Select Investor</option>
                          {investorUserList.map((investorUsers, index) => (
                            <option
                              value={JSON.stringify(investorUsers)}
                              selected={investorUsers?._id === ADDEDITDATA?.investor_id?._id}
                              key={index}
                            >
                              {investorUsers?.investor_first_name} {investorUsers?.investor_last_name} - ({investorUsers?.firm?.investor_firm_name})
                            </option>
                          ))}
                        </select>
                        {error.investor_id ? (
                          <p style={{ color: "red" }}>{error.investor_id}</p>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="company_id"
                          className="all_section_for_label_main_class  all_lebel_margin_top_main_div"
                        >
                        <span style={{ color: "red" }}>*</span>Select Company :
                        </label>
                        <select
                          className="form-control"
                          name="company_id"
                          id="company_id"
                          onChange={handleChange}
                        >
                          <option value="">Select Company</option>
                          {companyList.map((company, index) => (
                            <option
                              value={JSON.stringify(company)}
                              selected={company?._id === ADDEDITDATA?.company_id?._id}
                              key={index}
                            >
                              {company.company_name}
                            </option>
                          ))}
                        </select>
                        {error.company_id ? (
                          <p style={{ color: "red" }}>{error.company_id}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  
                  <div className="row">
                      {/* Priority */}
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="priority"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span> Priority :
                        </label>

                        <select
                          className="form-control"
                          name="priority"
                          id="priority"
                          value={ADDEDITDATA?.priority || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Priority</option>
                          <option value="first">First</option>
                          <option value="second">Second</option>
                        </select>

                        {error.priority ? (
                          <p style={{ color: "red" }}>{error.priority}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    
                      {/* Admin Approve Status */}
                      <div className="form-group col-lg-6 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                        <label
                          htmlFor="admin_status"
                          className="all_section_for_label_main_class all_lebel_margin_top_main_div"
                        >
                          <span style={{ color: "red" }}>*</span> Admin Approve Status :
                        </label>
                    
                        <select
                          className="form-control"
                          name="admin_status"
                          id="admin_status"
                          value={ADDEDITDATA?.admin_status || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Approve Status</option>
                          <option value="P">Pending</option>
                          <option value="A">Approved</option>
                        </select>
                    
                        {error.admin_status ? (
                          <p style={{ color: "red" }}>{error.admin_status}</p>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="button"
                    className="btn btn-primary inventory_save_button"
                    onClick={handleSubmit}
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <LoadingEffect isLoading={isLoading} /> */}
    </div>
  );
};

export default EventsEditPage;
